import React from 'react'
import { Grid, Box, Typography } from "@mui/material";
import UserCard from '../../components/card/user-card';
import { useNavigate } from 'react-router-dom';
import { paths } from '../routes/path';

const ShortListed = ({ candidates ,questions, setRefresh}) => {
    const navigate= useNavigate();
    const handleCardClick = (user) => {
        navigate(paths.evaluationScreen, { state: { user, questions } });
    };

    // Function to refresh the candidate list
    const handleStatusUpdate = (newStatus) => {
        // Trigger a refresh to update the candidate list
        setRefresh(prev => !prev);
    };

    return (
        <Box mt={3} p={2} sx={{ backgroundColor: "#fff", borderRadius: 2 }}>
            {candidates?.length > 0 ? (
                candidates.map((user, index) => (
                    <Grid item xs={12} sm={10} md={12} key={index}>
                        <UserCard
                        name={`${user.first_name} ${user.last_name}`}
                        date={user.human_date}
                        userStatus={user?.status}
                        id={user?.id} onClick={() => handleCardClick(user)}
                        onStatusUpdate={handleStatusUpdate} 
                        image={user?.image_url}
                        />
                    </Grid>
                ))
            ) : (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="300px">
                    <Typography variant="h3" color="gray"> Shortlisted candidates.</Typography>
                    <Typography variant="h6" color="gray"> There are No shortlisted candidates.</Typography>
                </Box>
            )}
        </Box>
    )
}

export default ShortListed;
